"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireScreenExtenderVisitor = void 0;
exports.extendQuestionnaireWithScreen = extendQuestionnaireWithScreen;
const lodash_1 = __importDefault(require("lodash"));
const screen_1 = require("../../types/carrierQuestionnaire/screen");
const QuestionnaireVisitor_1 = __importDefault(require("../QuestionnaireVisitor"));
class QuestionnaireScreenExtenderVisitor extends QuestionnaireVisitor_1.default {
    screenConfig;
    constructor(screenConfig) {
        super();
        this.screenConfig = screenConfig;
    }
    visitQuestionnaire(questionnaire) {
        const clonedQuestionnaire = lodash_1.default.cloneDeep(questionnaire);
        super.visitQuestionnaire(clonedQuestionnaire);
        return { questionnaire: clonedQuestionnaire, output: undefined };
    }
    visitField(field) {
        const fieldConfig = this.screenConfig?.[field.type] || this.screenConfig[screen_1.QuestionnaireScreenDefaultFieldName];
        if (fieldConfig?.optional !== undefined) {
            field.optional = fieldConfig.optional ? true : undefined;
        }
        if (fieldConfig?.validationType !== undefined) {
            field.validation.type = fieldConfig.validationType;
        }
        if (fieldConfig?.skipValidityConditions !== undefined && fieldConfig?.skipValidityConditions) {
            field.validIf = [];
        }
    }
}
exports.QuestionnaireScreenExtenderVisitor = QuestionnaireScreenExtenderVisitor;
function extendQuestionnaireWithScreen(questionnaire, screenConfig) {
    const visitor = new QuestionnaireScreenExtenderVisitor(screenConfig);
    const { questionnaire: extendedQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return extendedQuestionnaire;
}
